class BarracudaCount{
    constructor(element){
        this.element = element;
        this.element.classList.add("use-barracuda-count-initialized");

        this.container = document.createElement("DIV");
        this.container.classList.add("barracuda-count");
        this.element.classList.contains("hidden") ? this.container.classList.add("hidden") : false;

        this.element.parentElement.insertBefore(this.container, this.element)
        this.element.remove();
        this.container.appendChild(this.element);
        this.debouncer = null;

        //minus
        var minus = document.createElement("DIV");
        this.container.insertBefore(minus,this.element);
            minus.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus-circle"><line x1="8" y1="12" x2="16" y2="12"></line></svg>';
            minus.addEventListener("click",this.minus.bind(this)); 

        //plus
        var plus = document.createElement("DIV");
        this.container.appendChild(plus);
            plus.innerHTML= '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus-circle"><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>';
            plus.addEventListener("click",this.plus.bind(this));
    }
    plus(){
        this.element.value = !this.element.dataset.max && parseInt(this.element.dataset.max)<=parseInt(this.element.value)? this.element.dataset.max : parseInt(this.element.value) + 1;
        this.trigger();
    }
    minus(){
        this.element.value = parseInt(this.element.value) <= 0? 0: parseInt(this.element.value) - 1;
        this.trigger();
    }
    trigger(debouncer = false){
        
        /* Wait 400ms after last click before trigger action, and reload cart section. */
        if(!debouncer){
            clearTimeout(this.debouncer);
            this.debouncer = setTimeout((()=>{this.trigger(true)}).bind(this),400);
        }else{
        var event = new Event('change', {
            bubbles: true,
            cancelable: true,
        });
        
        this.element.dispatchEvent(event);
        }
    }
}

class BarracudaAjaxForm{
    constructor(form, button = null){
        form.classList.add("use-barracuda-ajax-form-initialized");
        this.debug = true;
        this.form = form
        this.message = null;
        this.button = button? button : ( form.querySelector("input[type=submit], button[type=submit]")?  form.querySelector("input[type=submit], button[type=submit]"): false)
        if(!this.button) console.error("BarracudaAjaxForm: button not found", form);
        if(this.button) this.button.addEventListener('click', this.send.bind(this));
    }
    send(event){
        event.preventDefault();
        this.form.classList.add("loading")
        axios({
            method: "post",
            url: this.form.action,
            data: new FormData(this.form),
            headers: { "Content-Type": "multipart/form-data" },
          })
        .then(function (response) {
            var x = document.createElement("html");
            x.innerHTML=response.data;
            if(x.querySelector(".shopify-challenge__container, #g-recaptcha")){
                this.form.submit();
            }else if(x.querySelector("#page-content .ajax-form-success")) {

                if(this.form.dataset.renew &&  x.querySelector("#"+this.form.dataset.renew) && document.getElementById(this.form.dataset.renew))
                    document.getElementById(this.form.dataset.renew).replaceWith( x.querySelector("#"+this.form.dataset.renew))
                
                this.success(x.querySelector("#page-content .ajax-form-success"))
            }
            else if(x.querySelector("#page-content .ajax-form-failure")) {
                this.failure(x.querySelector("#page-content .ajax-form-failure"))
            }else{
                if(this.button.dataset.redirect)
                    window.location = this.button.dataset.redirect
                else if(this.form.action)
                    window.location.href = this.form.action
                else
                    this.form.submit();
            }
        }.bind(this))
        .catch((function (error) {
            console.error(error);
            this.form.submit();
        }).bind(this));
    }
    success(success = null){
        if(success){
            this.message = success;
            this.form.appendChild(this.message)
            this.message.addEventListener("click", this.erase.bind(this));
            this.form.classList.add("form-success");
        }
        this.form.classList.remove("loading");
    }
    failure(error = null){
        if(error){
            this.message = error;
        }else{
            this.message = document.createElement("div")
            this.message.classList.add("ajax-form-failure")
            this.message.innerHTML = "<span>Connection failed</span>"
        }
        this.form.appendChild(this.message)
        this.message.addEventListener("click", this.hide.bind(this));
        this.form.classList.add("form-failure");
        
        this.form.classList.remove("loading");
    }
    hide(){
        this.form.classList.remove("form-success");
        this.form.classList.remove("form-failure");
        if(this.message) {
            this.message.removeEventListener("click", this.hide.bind(this));
            this.message.remove();
        }
    }
    erase(){
        this.form.reset();
        this.hide();
    }
}